<template>
<div
    v-if="banner_branding != null"
>
    <div
        class="app_bar"
        v-bind:class="{ 'app_bar' : true, 'app_bar_with_org_name' : value != null }"
        v-if="!banner_branding.use_logo || banner_branding.logo_image_url == null"
    >
        <v-icon
            size="75"
            color="white"
        >
            mdi-cash-usd-outline
        </v-icon>
        <br/>
        {{banner_text}}
    </div>

    <div
        v-else
    >
         <div
            :style="style_logo_background"
        >
            <img
                :src="banner_branding.logo_image_url"
                :style="style_logo"
            />
        </div>

    </div>
</div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: function() { return null; }
        },

        banner_branding: {
            type: Object,
            default: function() { return null; }
        },
    },

    computed: {
        style_logo() {
            let settings = this.banner_branding;
            if ( settings == null ) return '';
            
            let extra_css = settings.logo_image_css == null ? '' : settings.logo_image_css;

            return `max-width: ${settings.image_max_width}px; max-height: ${settings.image_max_height}px; ` + extra_css;
        },

        style_logo_background() {
            let settings = this.banner_branding;
            if ( settings == null ) return '';

            let extra_css = settings.logo_background_css == null ? '' : settings.logo_background_css;

            return `text-align: center; background-color: ${settings.background_color}; ` + extra_css;
        },

        banner_text() {
            if ( this.banner_branding != null && this.banner_branding.banner_text != null && this.banner_branding.banner_text.trim().length > 0 )
                return this.banner_branding.banner_text.trim();

            return this.value;
        },
    },
}
</script>

<style lang="scss" scoped>
.app_bar {
    width: 100%;
    height: 80px;
    background-color: #5D647C;
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    color: white;
}

.app_bar_with_org_name {
    height: 130px;
}
</style>